import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";

export const useBreakpointDown = (breakpoint: Breakpoint = "sm") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
